// image-processing-loader
var previousRequest = require("!!../../../../../node_modules/fox-file-loader/index.js!../../../../../node_modules/file-loader/index.js?name=[path][name].[ext]!./_tips-img.jpg");
var dir = previousRequest.replace("_tips-img.jpg", "")
module.exports = require("!../../../../../node_modules/fox-image-optimize-plugin/router.js")({
	dir: dir,
	base: "_tips-img.jpg",
	name: "_tips-img",
	ext: ".jpg",
	query: ""
}, previousRequest);


//////////////////
// WEBPACK FOOTER
// ./images/_tips-img.jpg
// module id = 948
// module chunks = 4